module.exports = __webpack_public_path__ + "media/images/award-badges-a7878203bcfc782e862de3aa174e3e18.svg";